<template lang="pug">
.pt-8
  v-row
    v-col(md="3")
      v-text-field(
        name="email",
        outlined,
        v-model="email",
        label="Email",
        :disabled="!isEdit"
      )
    v-col(md="3")
      v-text-field(
        name="phone",
        outlined,
        v-model="phone",
        label="Phone",
        :disabled="!isEdit"
      )

  v-row
    v-col(md="3")
      v-text-field(
        outlined,
        v-model="first_name",
        label="Given name",
        :disabled="!isEdit"
      )
    v-col(md="3")
      v-text-field(
        outlined,
        v-model="last_name",
        label="Family name",
        :disabled="!isEdit"
      )

  v-row
    v-col(md="6")
      .d-flex
        v-spacer
        v-btn.mr-4(text, v-if="isEdit", @click="cancel") cancel
        v-btn(v-if="!isEdit", @click="isEdit = !isEdit", color="primary") edit
        v-btn(v-else, color="primary", @click="save", :loading="loading") save
</template>

<script>
export default {
  data() {
    return {
      isEdit: false,
      loading: false,
      email: this.$auth.user().email,
      phone: this.$auth.user().phone,
      first_name: this.$auth.user().first_name,
      last_name: this.$auth.user().last_name,
    };
  },

  methods: {
    cancel() {
      this.isEdit = false;
      this.email = this.$auth.user().email;
      this.phone = this.$auth.user().phone;
      this.first_name = this.$auth.user().first_name;
      this.last_name = this.$auth.user().last_name;
    },

    save() {
      const { email, phone, first_name, last_name } = this;
      const body = {
        email,
        phone,
        first_name,
        last_name,
      };
      this.loading = true;
      this.axios.put("/current_user", body).then(() => {
        this.$auth.fetch();
        this.isEdit = false;
        this.loading = false;
      });
    },
  },
};
</script>